class Biodata {
    constructor({
        id,
        fullName,
        ageRange,
        caste,
        height,
        dob,
        gender,
        income,
        qualification,
        workplace,
        maritalStatus,
        status,
        imagePaths,
        createdAt,
        createdBy
    }) {
        if (!id || !fullName || !gender || !status || !createdAt) {
            throw new Error('Biodata entity requires id, fullName, gender, status, and createdAt.');
        }

        this.id = id;
        this.fullName = fullName;
        this.ageRange = ageRange;
        this.caste = caste;
        this.height = height;
        this.dob = dob;
        this.gender = gender;
        this.income = income;
        this.qualification = qualification;
        this.workplace = workplace;
        this.maritalStatus = maritalStatus;
        this.status = status;
        this.imagePaths = imagePaths || [];
        this.createdAt = createdAt;
        this.createdBy = createdBy || null;
    }
}

export default Biodata;
